import { Step } from 'react-joyride';

export enum WalkthroughIds {
  ThreadsBot = 'walkthrough-threadsbot',
  LiveView = 'walkthrough-liveview',
  CreateThread = 'walkthrough-createthread',
  Profile = 'walkthrough-profile',
  References = 'walkthrough-references',
  Copilot = 'walkthrough-copilot',
  InviteUsers = 'walkthrough-inviteusers',
}

export type WalkthroughRoute = 'dashboard' | 'thread' | '3d-viewer' | 'settings';

export const stepsByRoute: Record<WalkthroughRoute, Step[]> = {
  dashboard: [
    {
      placement: 'center' as const,
      target: 'body',
      title: 'Welcome to Threads!',
      content: 'Threads is a tool that helps you capture design decisions. Click Next for a tour.',
    },
    {
      target: `#${WalkthroughIds.ThreadsBot}`,
      title: 'ThreadsBot',
      content:
        'Threadsbot is an integrated AI assistant and can answer questions about the data added to your workspace.',
    },
    {
      target: `#${WalkthroughIds.LiveView}`,
      title: 'Live View',
      content: `Live View helps you keep track of Threads and Events in your workspace in a calendar-like format`,
    },
  ],
  thread: [
    {
      placement: 'center' as const,
      target: 'body',
      title: 'What is a Thread?',
      content:
        'Here is where you can invite contributors, discuss a topic, upload files and links and notate on a 3D file',
    },
    {
      target: `#${WalkthroughIds.References}`,
      title: 'Files and Links',
      content: 'Here you can attach files and links to the Thread',
    },
    {
      target: `#${WalkthroughIds.Copilot}`,
      title: 'ThreadsBot',
      content: 'ThreadsBot suggestions allow you to quickly create and update Events from comments',
    },
  ],
  settings: [
    {
      placement: 'center' as const,
      target: 'body',
      title: 'Workspace Settings',
      content: 'Here you can manage workspace users and integrations',
    },
    {
      target: `#${WalkthroughIds.InviteUsers}`,
      title: 'Invite Users',
      content: 'Click here to invite new users to your workspace',
    },
  ],
  '3d-viewer': [
    {
      placement: 'center' as const,
      target: 'body',
      title: 'Threads3D',
      content: `Threads3D is a 3D model viewer for STL and STEP files.
        Click anywhere on the model to create an annotation and start a comment thread`,
    },
  ],
};
